import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quote-form"
export default class extends Controller {
  static targets = ["lineItemPrice", "totalPrice"]

  connect() {
    this.calculateTotal()
  }

  calculateTotal() {
    let total = 0

    this.lineItemPriceTargets.forEach(input => {
      const value = parseFloat(input.value) || 0
      total += value
    })

    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.value = total.toFixed(2)
    }
  }
}
